module.exports = __webpack_public_path__ + "static/media/no1.7deeede3.png";